import React from 'react';
import { ChevronDown } from 'lucide-react';
export function Navigation() {
  const navItems = [{
    label: 'Business',
    hasDropdown: true
  }, {
    label: 'Operations',
    hasDropdown: true
  }, {
    label: 'Writers',
    hasDropdown: true
  }, {
    label: 'Multimedia',
    hasDropdown: true
  }, {
    label: 'Resources',
    hasDropdown: true
  }, {
    label: 'Advertising',
    hasDropdown: true
  }, {
    label: 'Subscribe',
    hasDropdown: true
  }, {
    label: 'MEAT + POULTRY RED BOOK®',
    hasDropdown: false
  }];
  return <nav className="hidden md:block py-3 border-b border-black" data-id="element-225" data-mp="jz5akq1u1mww">
      <ul className="flex flex-wrap justify-between items-center text-[15px] text-gray-800" data-id="element-226" data-mp="f0bzt5dxka0f">
        {navItems.map((item, index) => <li key={index} data-id="element-227" data-mp="t0mpi53i7ik0" data-mpi={index}>
            <a href="#" className="flex items-center gap-1 hover:text-[#002f5f] transition-colors group" data-id="element-228" data-mp="oyrshcslvrc1">
              {item.label}
              {item.hasDropdown && <ChevronDown className="w-4 h-4 text-gray-500 group-hover:text-[#002f5f]" strokeWidth={2} data-id="element-229" data-mp="hh198dlhm7qy" />}
            </a>
          </li>)}
      </ul>
    </nav>;
}